export const ProductType = {
    OpenValue: 1,
    Package: 2,
    Goods: 3,
    Delivery: 4,
    Company: 5,
    PackageSpecDates: 6
}
export const OrderStatus = {
    Cancelled: 0,
    Reserved: 1,
    InProcess: 2,
    Used: 3,
    CancellationPending: 4,
    CancellationRefunded: 5,
    RedemptionPending: 6,
    Redeemed: 7,
    UsedPartially: 8,
    Pending: 9
}
export const MethodOfPayment = {
    CreditCard: 1,
    BankTransfer: 2
}
export const ErrorCodes = {
    SetOrder: 100,
    GetPciIframe: 200,
    GetVoucher: 300,
    GetBlockedProduct: 400,
    GetUserIp: 500
}